module.exports = __webpack_public_path__ + "img/f835f87.png";